import React, { Component } from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getSalary, saveSalary } from "../../services/salaryService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table, Grid, Button } from "semantic-ui-react";
import auth from "../../services/authService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Input from "../common/input";

class SalaryEditForm extends Component {
  state = {
    salary: { salary_detail: [] },
    errors: {}
  };

  schema = {
    name: Joi.string()
      .required()
      .label("Ledger type")
  };

  async populateLedgerType() {
    try {
      this.loadAllData();
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    await this.populateLedgerType();
  }

  async loadAllData() {
    const ledgerTypeId = this.props.match.params.id;
    this.setState({ blocking: true });
    const { data: salary } = await getSalary(ledgerTypeId);

    this.setState({ blocking: false, salary });
  }

  confirmSalary = async visaId => {
    this.setState({ blocking: true });
    const hour = document.getElementById(visaId).value;

    // var event = new Date(this.state.salary.work_date);
    // let date = JSON.stringify(event);
    // date = date.slice(1, 11);

    const verifyData = {
      visaId: visaId,
      hour: hour,
      salary_date: this.state.salary.work_date
    };
    try {
      await saveSalary(verifyData);
      document.getElementById(visaId).value = "";
      this.loadAllData();
      toast.success("Entry has been updated successfully.");
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        toast.warning("Hours should be only numbers");
      }
    }

    this.setState({ blocking: false });
  };

  render() {
    if (auth.getCurrentUser().role != "client") {
      return "Your are authorized to perform this action.";
    }

    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <TableTitle title="Update salary" icon="tag" />
        <center>
          <div className="outer-container">
            <Grid columns={2} divided>
              <Grid.Row>
                <Grid.Column>
                  <Table definition>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell width={4}>Salary Date</Table.Cell>
                        <Table.Cell>{this.state.salary.work_date}</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Grid.Column>
                <Grid.Column>
                  <Table definition>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell width={4}>Entry Date</Table.Cell>
                        <Table.Cell>{this.state.salary.entry_date}</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <div class="ui error form" style={{ marginTop: 15 }}>
              <Table celled fixed singleLine>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell width={4}>Name</Table.HeaderCell>
                    <Table.HeaderCell width={3}>Mobile</Table.HeaderCell>
                    <Table.HeaderCell width={3}>Company</Table.HeaderCell>
                    <Table.HeaderCell width={2}>Hours</Table.HeaderCell>
                    <Table.HeaderCell width={2}>Update Hours</Table.HeaderCell>
                    <Table.HeaderCell width={2}></Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {this.state.salary.salary_detail.map(visa => (
                    <Table.Row key={visa.visa.id}>
                      <Table.Cell>{visa.visa.name}</Table.Cell>
                      <Table.Cell>{visa.visa.mobile}</Table.Cell>
                      <Table.Cell>{visa.visa.company.name}</Table.Cell>
                      <Table.Cell>{visa.hours}</Table.Cell>
                      <Table.Cell>
                        <input
                          maxlength="2"
                          // value={visa.hours}
                          type="text"
                          id={visa.visa.id}
                        />
                      </Table.Cell>
                      <Table.Cell>
                        <Button
                          color="green"
                          onClick={() => this.confirmSalary(visa.visa.id)}
                        >
                          Confirm
                        </Button>
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          </div>
        </center>
      </BlockUi>
    );
  }
}

export default SalaryEditForm;
